const isSingleSelect = (select: HTMLSelectElement | NodeListOf<HTMLSelectElement>): select is HTMLSelectElement => {
    return "nodeName" in select;
};

export const getApplicationOptionsFromForm = (form: HTMLFormElement) => {
    const applicationOptions: number[] = [];
    if (!form["application"]) {
        return applicationOptions;
    }
    if (isSingleSelect(form["application"])) {
        applicationOptions.push(parseInt(form["application"].value, 10));
    } else {
        form["application"]?.forEach((select: HTMLSelectElement) => {
            if (select.value) {
                applicationOptions.push(parseInt(select.value, 10));
            }
        });
    }
    return applicationOptions.filter((id): id is number => !isNaN(id));
};
